import React from 'react';
import { Icon } from '@iconify/react';
import { Button, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useOktaAuth } from '@okta/okta-react';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

const SessionExpireDialog = ({ open, onClose }: Props) => {
  // use hooks
  const { oktaAuth } = useOktaAuth();

  // handling close
  const handleClose = (event: any, reason: any) => {
    if (reason && reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle sx={{ padding: '16px 20px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={18} fontWeight={700}>
            Your session has expired
          </Typography>
          {/* <Box>
            <IconButton size="small" sx={{ fontSize: '24px' }}>
              <Icon onClick={onClose} icon="ei:close" />
            </IconButton>
          </Box> */}
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 420, padding: '0px 20px 20px', maxWidth: '460px' }}>
        <Typography fontSize={16} fontWeight={400} lineHeight="24px">
          Please log in again to continue using your Vehicle 360.
        </Typography>
        <Divider sx={{ borderColor: '#EDEDED', marginTop: '10px', marginBottom: '10px' }} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => {
              oktaAuth.signInWithRedirect();
              onClose();
            }}
            variant="contained"
            sx={{
              fontSize: 14,
              fontWeight: 400,
              color: '#fff',
              borderRadius: '4px',
              textTransform: 'none',
              padding: '8px 15px',
              lineHeight: '20px',
              border: '1px solid #456BD9',
              marginLeft: '15px',
            }}
          >
            Sign in
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SessionExpireDialog;
